<template>
    <div>
        <!-- <b-table class="mt-3" hover :items="items"></b-table> -->
        <div class="row">
            <!-- <button class="btn btn-success" v-on:click="exportExcel()"></button> -->
            <!-- <div class="form-group float-left row col-xs-12 col-sm-3">
                <label for="staticEmail" class="col-sm-3 col-xs-12 col-form-label">Search :</label>
                <div class="col-sm-9 col-xs-12">
                    <input type="text" placeholder="Input Text Here" class="form-control" v-model="searchText"></input>
                </div>
            </div> -->
            <download-excel
            class   = "btn btn-success col-xs-12 offset-sm-9 col-sm-3 p-5"
            style="height:50%"
            :fetch = "exportExcel"
            :fields = "json_fields"
            type = 'xls'
            :name    = name>

            <i class="fas fa-file-excel"></i> Export to Excel
            </download-excel>
        </div>
        <div class="table-div mt-3">
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th class="headTitle" v-for="header in tableHeaders" @click="selectSort(header.value)">{{ header.name }}</th>
                        <th>Options</th>
                    </tr>
                </thead>
                <tbody >
                    <tr v-for="item in items" >
                        <td>{{item.qrcode}}</td>
                        <td>{{item.frame_no}}</td>
                        <td>{{item.type}}</td>
                        <td>{{item.manufacture_year}}</td>
                        <td>{{item.location}}</td>
                        <td>{{new Date(item.date - (new Date()).getTimezoneOffset() * 60000).toISOString().replace("T" , " ").slice(0,19)}}</td>
                        <td>{{item.status}} </td>
                        <td>{{item.times_replaced}} </td>
                        <td class="row">
                            <button type="button" class="btn btn-secondary btn-md mr-1"  @click="selectVehicle(item.id)"><i class="fas fa-info-circle fa-lg"></i></button>
                            <button type="button" class="btn btn-warning btn-md ml-1"  @click="qrcodeDetail(item)"><i class="fas fa-truck-moving fa-lg"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <hr>
        <p v-if="meta">Showing {{1 + ((meta.currentPage - 1) * 10)}} to {{meta.currentPage != meta.lastPage ? meta.currentPage * 10 : meta.total}} of {{meta.total}} entries.</p>
        
        <div class="row">
            <div class="col" style="padding: 20px">
                <nav>
                    <ul class="pagination" style="justify-content:center">
                        <li class="page-item" :class="{'disabled' : (config.currentPage <= 1)}" @click="laquo()">
                            <span class="page-link">&laquo;</span>
                        </li>
                        <li class="page-item" :class="{'disabled' : (config.currentPage <= 1)}" @click="lsaquo()">
                            <span class="page-link">&lsaquo;</span>
                        </li>
                        <li class="page-item pageNumber" style="cursor:pointer">
                            <span class="page-link" style="color:black">
                                <span style="font-weight: bold;">{{(config.maxPage < 1) ? 0 : config.currentPage}}</span> of {{config.maxPage}}
                            </span>
                        </li>
                        <li class="page-item" :class="{'disabled' : (config.currentPage >= config.maxPage)}" @click="rsaquo()">
                            <span class="page-link">&rsaquo;</span>
                        </li>
                        <li class="page-item" :class="{'disabled' : (config.currentPage >= config.maxPage)}" @click="raquo()">
                            <span class="page-link">&raquo;</span>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>

        <div v-if="viewModal" >
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper" @click="viewModal = false">
                        <div class="row">
                            <div class="col-xs-1 col-sm-1 col-md-2 col-lg-2"></div>
                            <div class="col-xs-10 col-sm-10 col-md-8 col-lg-8">
                                <div class="modal-container" @click.stop>
                                    <div class="modal-body text-center">
                                        <mapDetailModal :data="data"></mapDetailModal>
                                        <button class="btn btn-primary" v-on:click="viewModal = false">Done</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-4"></div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import debounce from 'debounce'
import mapDetailModal from './mapDetailModal';

export default {
    components : {
        mapDetailModal
    },
    data(){
        return {
            items : [],
            options : { year: 'numeric', month: 'long', day: 'numeric' },
            config : {
                currentPage : 1,
                maxPage : 1,
                limitPerPage : 10,//LIMIT PER PAGE
                by : 'date',
                order : false,//true = ascending, false = descending, for start, Reverted
            },
            excelData : null,
            tableHeaders : [],
            tableHeaderTitles : [],
            json_fields: {
                'QRCode': 'qrcode',
                'Frame Number': 'frame_no',
                'Type': 'type',
                'Manufacture Year' : 'manufacture_year', 
                'Date' : 'date',
                'Status' : 'status'
            },
            searchText : '',
            name : 'Mapping Report ' + new Date().toISOString().replace('T').slice(0,10) + '.xls',
            viewModal : false,
            data : null,
            meta : null
        }
    },
    created(){
        this.fetchData = debounce(this.fetchData, 1000)
    },
    mounted(){
        this.addTableHeader('qrcode', 'QRCode')
        this.addTableHeader('frame_no', 'Frame Number')
        this.addTableHeader('type', 'Type')
        this.addTableHeader('manufacture_year', 'Manufacture Year')
        this.addTableHeader('location', 'Location')
        this.addTableHeader('date', 'Scan Date')
        this.addTableHeader('status', 'Status')
        this.addTableHeader('times_replaced', 'Replaced')

        this.selectSort('date');//ACT AS FETCH DATA FUNCTION
    },
    watch : {
        '$store.state.updateData' : function(){
            this.fetchData(1);
        },
        searchText : function(){
            this.fetchData(1);
        }
    },
    methods : {
        qrcodeDetail(item){
            this.$router.push({ name : 'ObjectSearchDetail' , params : {frame_no : item.frame_no}})
        },
        selectVehicle(id){
            let url = '/api/vehicle/get-data?id=' + id
            this.$http.get(url)
            .then((resp)=>{
                this.data = resp.data.data[0];
                this.viewModal = true;
            })
            .catch((err)=>{
                console.log(err);
            })
        },
        async exportExcel(){
            let url = "/api/vehicle/map/excel" + this.$store.state.filterUrl;
            // ;

            // if(this.searchText != '')
            //     url = url + "rq_uuid=" + this.searchText;

            return await this.$http.get(url)
            .then((resp)=>{
                if(resp.data.code != 200)
                    throw new Error(resp.data.message)
                var data = resp.data.data;
                var tzoffset = (new Date()).getTimezoneOffset() * 60000;

                for(var i = 0 ; i < data.length ; i++){
                    data[i].date = new Date(new Date(data[i].date) - tzoffset).toISOString().slice(0, 19).replace('T', ' ')
                }
                return data;
            })
            .catch((err)=>{
                console.log(err);
                
            });
        },
        reportDetailPage(rquuid, data){
            this.$router.push({ name : "LogReportDetails" , params : {rquuid : rquuid , data : data }})
        },
        newError(errorMessage){
            var error = "%c" + errorMessage;
            console.log(error, 'color:#ff0000')
        },
        laquo(){//first page
            if(this.config.currentPage-1 > 0){
                this.fetchData(1);
            } else {
                this.newError("First Page Reached!");
            }
        },
        lsaquo(){//previous page
            if(this.config.currentPage-1 > 0){
                this.fetchData(this.config.currentPage-1);
            } else {
                this.newError("Last Page Reached!");
            }
        },
        rsaquo(){//next page
            if(this.config.currentPage+1 <= this.config.maxPage){
                this.fetchData(this.config.currentPage+1);
            } else {
                this.newError("Last Page Reached!");
            }
        },
        raquo(){//last page
            if(this.config.currentPage+1 <= this.config.maxPage){
                this.fetchData(this.config.maxPage);
            } else {
                this.newError("Last Page Reached!");
            }
        },
        selectSort(sortVariable){
            if(sortVariable == null){
                alert('Feature Unavailable');
                return;
            }
            if(this.config.by != sortVariable){
                this.config.by = sortVariable
                this.config.order = false
                this.fetchData(1)
            } else {
                this.config.order = !this.config.order
                if(this.config.order)
                    this.fetchData(1)
                else
                    this.fetchData(1)
            }
            this.changeSortTitle();
        },
        changeSortTitle(){
            for(var i = 0; i < this.tableHeaders.length; i++){
                if(this.config.by == this.tableHeaders[i].value){
                    if(this.config.order)
                        this.tableHeaders[i].name = this.tableHeaderTitles[i] + '▲'
                    else
                        this.tableHeaders[i].name = this.tableHeaderTitles[i] + '▼'
                } else {
                    this.tableHeaders[i].name = this.tableHeaderTitles[i]
                }
            }
        },
        addTableHeader(variable, title){
            let header = {
                value : variable,
                name : title
            }
            this.tableHeaders.push(header);
            this.tableHeaderTitles.push(title);
        },
        fetchData(page){//PAGE(1,2,3,4)

            if(this.$store.state.filterUrl == '')
                return;
                
            var url = `/api/vehicle/map${this.$store.state.filterUrl}`;

            url = `${url}&limit=${this.config.limitPerPage}&order=${(this.config.order)?'ASC':'DESC'}&by=${this.config.by}`//ADDS LIMIT, ORDER, AND BY

            if(page)
                url = url + '&page=' + page;

            this.$http.get(url)
            .then((resp)=>{
         
                var data = resp.data.data;
                var meta = resp.data.meta;

                this.meta = meta;

                this.config.currentPage = meta.currentPage;
                this.config.maxPage = meta.lastPage;

                for(var i = 0 ; i < data.length ; i++){
                    data[i].date =  new Date(data[i].date);
                }

                this.items = data;
            })
            .catch((err)=>{
                console.log(err);
            })
        },
    }
}
</script>

<style scoped>
    .fa-truck-moving{
        color:black;
    }
    tr:hover{
        cursor: pointer;
    }
    .statusFailed{
        background-color: #ff7152;
    }
    .statusSuccess{
        background-color: #68edb6;
    }
    .statusStyle{
        font-weight: bold;
        color : white;
        padding:3px 20px;
        width: 80px;
    }
    .headTitle{
        cursor: pointer;
    }
    .page-link{
        cursor: pointer;
    }
    .pageNumber .page-link:hover{
        background-color: white;
        cursor: default;
    }
    .disabled .page-link{
        background-color:#EEEEEE;
    }
    li .disabled:hover{
        cursor: default;
    }
    .table-div{
        display: block;
        overflow: scroll;
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 10px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* MODAL STARTS */
    .modal-body{
        margin:0
    }

    .modal-body .moduleLine{
        margin-bottom: 0vh;
    }

    .modal-body .moduleLine a{
        text-decoration: none;
    }

    .modal-body .moduleLine .moduleBox:hover{
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }

    .modal-body .moduleLine .moduleBox{
        border:1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color:black;
        margin-bottom: 3vh;
    }

    .modal-body .moduleLine .moduleBox i{
        font-size:5vh;
    }

    h3.modalHeadline{
        margin:0 0 20px 0
    }
    /* MODAL ENDS */

    .modalContent tr th{
      text-align:right;
    }

    .modalContent tr .middleDivider{
      width: 50px;
      text-align: center;
    }
</style>

